import { Component, ContextType, ReactNode } from 'react';
import { FormikConsumer, FormikContextType } from 'formik';
import { AnyObjectSchema, Asserts } from 'yup';

import BraxFormContext from '../context';

export type BraxFormikProps<Schema extends AnyObjectSchema = AnyObjectSchema> = {
    children: (props: ContextType<typeof BraxFormContext> & FormikContextType<Asserts<Schema>>) => ReactNode
};

export class BraxFormik<Schema extends AnyObjectSchema = AnyObjectSchema> extends Component<BraxFormikProps<Schema>> {

    render() {
        return (
            <BraxFormContext.Consumer>
                { context => (
                    <FormikConsumer>
                        { (formik: FormikContextType<Asserts<Schema>>) => this.props.children({ ...formik, ...context }) }
                    </FormikConsumer>
                ) }
            </BraxFormContext.Consumer>
        );
    }

}
